import React from 'react';

import { FilesHubView } from '../features/user-files/components/FilesHubView';

export const UserFilesPage: React.FC = () => <FilesHubView />;
